export class SetTaxesFormState {
  static readonly type = '[TaxesForm] SetTaxesFormState';
  constructor(public payload: string) {}
}

export class SetFederalFilingStatus {
  static readonly type = '[TaxesForm] SetFederalFilingStatus';
  constructor(public payload: string) {}
}

export class SetFederalWithholdingAllowance {
  static readonly type = '[TaxesForm] SetFederalWithholdingAllowance';
  constructor(public payload: number) {}
}

export class SetFederalAddlWithholdingType {
  static readonly type = '[TaxesForm] SetFederalAddlWithholdingType';
  constructor(public payload: string) {}
}

export class SetFederalAddlWithholdingValue {
  static readonly type = '[TaxesForm] SetFederalAddlWithholdingValue';
  constructor(public payload: number) {}
}

export class SetHasSSExemption {
  static readonly type = '[TaxesForm] SetHasSSExemption';
  constructor(public payload: boolean) {}
}

export class SetHasMEDCExemption {
  static readonly type = '[TaxesForm] SetHasMEDCExemption';
  constructor(public payload: boolean) {}
}

export class SetHasSUIExemption {
  static readonly type = '[TaxesForm] SetHasSUIExemption';
  constructor(public payload: boolean) {}
}

export class SetHasFUTAExemption {
  static readonly type = '[TaxesForm] SetHasFUTAExemption';
  constructor(public payload: boolean) {}
}

export class SetHasDisLeaveExempt {
  static readonly type = '[TaxesForm] SetHasDisLeaveExempt';
  constructor(public payload: boolean) {}
}

export class SetHasFamilyLeaveExempt {
  static readonly type = '[TaxesForm] SetHasFamilyLeaveExempt';
  constructor(public payload: boolean) {}
}

export class SetHasMedLeaveExempt {
  static readonly type = '[TaxesForm] SetHasMedLeaveExempt';
  constructor(public payload: boolean) {}
}

export class SetFUTAExemptionReason {
  static readonly type = '[TaxesForm] SetFUTAExemptionReason';
  constructor(public payload: string) {}
}

export class SetJ1F1Visa {
  static readonly type = '[TaxesForm] SetJ1F1Visa';
  constructor(public payload: string) {}
}

export class SetExpireDate {
  static readonly type = '[TaxesForm] SetExpireDate';
  constructor(public payload: { year: number; month: number; day: number }) {}
}

export class SetWithHoldingState {
  static readonly type = '[TaxesForm] SetWithHoldingState';
  constructor(public payload: string) {}
}

export class SetStateFilingStatus {
  static readonly type = '[TaxesForm] SetStateFilingStatus';
  constructor(public payload: string) {}
}

export class SetStateWithholdingAllowance {
  static readonly type = '[TaxesForm] SetStateWithholdingAllowance';
  constructor(public payload: any) {}
}

export class SetStateAddlAllowances {
  static readonly type = '[TaxesForm] SetStateAddlAllowances';
  constructor(public payload: any) {}
}

export class SetStateAddlWithholdingType {
  static readonly type = '[TaxesForm] SetStateAddlWithholdingType';
  constructor(public payload: any) {}
}

export class SetStateAddlWithholdingValue {
  static readonly type = '[TaxesForm] SetStateAddlWithholdingValue';
  constructor(public payload: any) {}
}

export class SetAddlStateFilingStatus {
  static readonly type = '[TaxesForm] SetAddlStateFilingStatus';
  constructor(public payload: string) {}
}

export class SetAddlStateWithholdingAllowance {
  static readonly type = '[TaxesForm] SetAddlStateWithholdingAllowance';
  constructor(public payload: number) {}
}

export class SetAddlStateAddlAllowances {
  static readonly type = '[TaxesForm] SetAddlStateAddlAllowances';
  constructor(public payload: number) {}
}

export class SetAddlStateAddlWithholdingType {
  static readonly type = '[TaxesForm] SetAddlStateAddlWithholdingType';
  constructor(public payload: string) {}
}

export class SetAddlStateAddlWithholdingValue {
  static readonly type = '[TaxesForm] SetAddlStateAddlWithholdingValue';
  constructor(public payload: number) {}
}

export class SetIsExemptFromWithholding {
  static readonly type = '[TaxesForm] SetIsExemptFromWithholding';
  constructor(public payload: boolean) {}
}

export class SetW4Version {
  static readonly type = '[TaxesForm] SetW4Version';
  constructor(public payload: string) {}
}

export class SetIsHigherWithholding {
  static readonly type = '[TaxesForm] SetIsHigherWithholding';
  constructor(public payload: boolean) {}
}

export class SetChildTaxCredit {
  static readonly type = '[TaxesForm] SetChildTaxCredit';
  constructor(public payload: number) {}
}

export class SetOtherIncome {
  static readonly type = '[TaxesForm] SetOtherIncome';
  constructor(public payload: number) {}
}

export class SetWageDeduction {
  static readonly type = '[TaxesForm] SetWageDeduction';
  constructor(public payload: number) {}
}

export class SetLocals {
  static readonly type = '[TaxesForm] SetLocals';
  constructor(public payload: any[]) {}
}
